import { Select } from "antd";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Icon, { ICON_NAME } from "../../../../components/Icon";
import { selectSetting } from "../../../../util/store/selectors";
import { CALENDAR_VIEW, CALENDAR_VIEW_SIZE, calendarViews, VIEW_SMOOTH } from "../../../../util/varibles/constants";
import { getElById, renderOpts } from "../../../../util/varibles/global";
import { PlanSetting } from "../../../../util/varibles/userSetting";
import { updateUserSetting } from "../../../LoginPage/reducer";
import { CALENDAR_ID } from "../../constants";

export const calendarSizes: Record<string, { id: CALENDAR_VIEW_SIZE, icon: ICON_NAME, width: number }> = {
    [CALENDAR_VIEW_SIZE.ZOOM_IN]: {
        id: CALENDAR_VIEW_SIZE.ZOOM_IN,
        icon: ICON_NAME.ZOOM_IN,
        width: 70
    },
    [CALENDAR_VIEW_SIZE.ZOOM_OUT]: {
        id: CALENDAR_VIEW_SIZE.ZOOM_OUT,
        icon: ICON_NAME.ZOOM_OUT,
        width: 140
    }
}

export default function CalendarViewSelect() {
    const { [PlanSetting.CALENDAR_VIEW]: calendarView, [PlanSetting.CALENDAR_VIEW_SIZE]: calendarViewSize } = useSelector(selectSetting([PlanSetting.CALENDAR_VIEW, PlanSetting.CALENDAR_VIEW_SIZE]));
    const dispatch = useDispatch();
    const view = calendarView.indexOf(CALENDAR_VIEW.HORIZONTAL) !== -1 ? CALENDAR_VIEW.HORIZONTAL : CALENDAR_VIEW.VERTICAL;
    const initRef = useRef(false);
    const sizeRef = useRef(calendarSizes[calendarViewSize].width);

    useEffect(() => {
        const el = getElById(CALENDAR_ID);
        if (el) {
            const { scrollLeft } = el;
            el.dataset.setDateWidth = "true";
            const weekCount = scrollLeft / sizeRef.current;

            const { width = 70 } = calendarSizes[calendarViewSize] || {};
            el.style.setProperty('--date-per-screen', `${width}px`);
            if (initRef.current)
                el.scrollTo({ left: weekCount * width, ...VIEW_SMOOTH })
            else
                initRef.current = true;
            sizeRef.current = width;
            setTimeout(() => el.dataset.setDateWidth = "false", 100)
        }
    }, [calendarViewSize])

    return <div className="flex items-center gap-2">
        <Select
            variant={'borderless'}
            // disabled
            // suffixIcon={null}
            styles={{
                root: {
                    fontSize: 18
                },
                popup: {
                    root: {
                        minWidth: 220,
                    },
                },
            }}
            value={view}
            onChange={(value) => {
                dispatch(updateUserSetting([{ [PlanSetting.CALENDAR_VIEW]: value }]))
            }}
            options={renderOpts(calendarViews)}
        />
        {view === CALENDAR_VIEW.HORIZONTAL && <div className="flex items-center gap-1">
            {Object.keys(calendarSizes).map(key => {
                const { id, icon } = calendarSizes[key];
                return <div
                    key={id}
                    className="bt-ghost w-[32px]"
                    data-active={calendarViewSize === id}
                    data-icon="true"
                    onClick={() => dispatch(updateUserSetting([{ [PlanSetting.CALENDAR_VIEW_SIZE]: id }]))}
                >
                    <Icon icon={icon!} />
                </div>
            })}
        </div>}
    </div>

}
